import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { LuApple, LuChartNoAxesCombined, LuCloud, LuCloudOff, LuDumbbell, LuHouse, LuLogOut, LuMessageCircle, LuMoon, LuSun, LuUserRound } from "react-icons/lu";
import { useVelaAccount } from "../application/AccountContext";
import { useVela } from "../store/VelaStore";
import Coach from "./coach/Coach";

const nav = [
  { label: "Today", path: "/vela", icon: LuHouse, end: true },
  { label: "Train", path: "/vela/train", icon: LuDumbbell },
  { label: "Nutrition", path: "/vela/nutrition", icon: LuApple },
  { label: "Progress", path: "/vela/progress", icon: LuChartNoAxesCombined },
  { label: "Profile", path: "/vela/profile", icon: LuUserRound },
];

const Shell: React.FC = () => {
  const { data, toast, dismissToast, syncStatus } = useVela();
  const account = useVelaAccount();
  const navigate = useNavigate();
  const [dark, setDark] = useState(() => localStorage.getItem("vela-theme") === "dark");
  const [coach, setCoach] = useState(false);
  const [menu, setMenu] = useState(false);
  const location = useLocation();
  const focusMode = location.pathname.startsWith("/vela/workout/");

  useEffect(() => {
    if (!toast) return;
    const id = window.setTimeout(dismissToast, 4500);
    return () => window.clearTimeout(id);
  }, [toast, dismissToast]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setMenu(false);
  }, [location.pathname]);

  const toggle = () => setDark((value) => {
    localStorage.setItem("vela-theme", value ? "light" : "dark");
    return !value;
  });
  const syncLabel = syncStatus === "saved" ? "Saved" : syncStatus === "saving" ? "Saving…" : syncStatus === "offline" ? "Offline — changes queued" : "Sync needs attention";

  if (focusMode) return <div className={`vela-app vela-focus-mode ${dark ? "is-dark" : ""}`}><main className="vela-main"><Outlet /></main>{toast && <div className="vela-toast" role="status"><span>✓</span>{toast.message}{toast.action && <button onClick={toast.onAction}>{toast.action}</button>}</div>}</div>;

  return <div className={`vela-app ${dark ? "is-dark" : ""}`}>
    <aside className="vela-sidebar">
      <a className="vela-brand" href="/vela"><i>v</i><span><strong>vela</strong><small>adaptive fitness</small></span></a>
      <nav aria-label="Vela navigation">{nav.map(({ label, path, icon: Icon, end }) => <NavLink key={path} to={path} end={end}><Icon /><span>{label}</span></NavLink>)}</nav>
      <div className="vela-side-actions"><button onClick={() => setCoach(true)}><LuMessageCircle /><span>Ask coach</span></button><button onClick={toggle}>{dark ? <LuSun /> : <LuMoon />}<span>{dark ? "Light mode" : "Dark mode"}</span></button></div>
      <div className="vela-sync-state" data-state={syncStatus}>{syncStatus === "offline" ? <LuCloudOff /> : <LuCloud />}<span>{syncLabel}</span></div>
      <div className="vela-user-wrap"><button className="vela-user" onClick={() => setMenu((value) => !value)} aria-expanded={menu}><span>{data.profile.name[0]}</span><div><strong>{data.profile.name}</strong><small>{account.mode === "demo" ? "Demo mode" : account.email}</small></div></button>{menu && <div className="vela-user-menu"><button onClick={() => navigate("/vela/profile/account")}>Account settings</button><button onClick={async () => { await account.signOut(); navigate("/vela"); }}><LuLogOut /> Sign out</button></div>}</div>
    </aside>
    <header className="vela-mobile-head"><a className="vela-brand" href="/vela"><i>v</i><strong>vela</strong></a><div className="vela-mobile-sync" aria-label={syncLabel}>{syncStatus === "offline" ? <LuCloudOff /> : <LuCloud />}</div><button onClick={() => setCoach(true)} aria-label="Ask coach"><LuMessageCircle /></button></header>
    <main className="vela-main"><Outlet /></main>
    <nav className="vela-bottom-nav" aria-label="Vela mobile navigation">{nav.map(({ label, path, icon: Icon, end }) => <NavLink key={path} to={path} end={end}><Icon /><span>{label}</span></NavLink>)}</nav>
    <Coach open={coach} onClose={() => setCoach(false)} />
    {toast && <div className="vela-toast" role="status"><span>✓</span>{toast.message}{toast.action && <button onClick={toast.onAction}>{toast.action}</button>}</div>}
  </div>;
};

export default Shell;
